module.exports = __webpack_public_path__ + "static/media/img107.3cf127bf.jpg";